export default __webpack_public_path__ + "static/feature1-86bcacf789bbbaaf476a9370e56256c6.webp";